module.exports = __webpack_public_path__ + "img/akfel-wgc-paris-multitouch-application-11.1ec1557b.png";